import React from 'react';
import PropTypes from 'prop-types';

import PaymentTypes from './PaymentTypes';
import Insurances from './Insurances';
import SpecialOffers from './SpecialOffers';

import { filterErrors, TextareaField } from '../../common';

export default function ClientBilling({
  values,
  errors,
  onChange,
  onInputChange,
  paymentTypes,
  insurances,
  recipients,
  getHandler,
  auth,
  billing,
  preferences,
}) {
  const { properties } = billing;
  return (
    <div className="bookings client-billing">
      {properties?.payment_types && (
        <>
          <div className="bookings__row">
            <p className="bookings__row__label main-title less-padding">
              {properties?.payment_types?.description
                || 'What forms of payment do you accept?'}
            </p>
          </div>
          <div className="bookings__row">
            <div className="bookings__row__input reduce-padding">
              <PaymentTypes
                paymentvalues={preferences.paymentTypes}
                errors={filterErrors('paymentTypes', errors)}
                onChange={onInputChange}
                paymentTypes={paymentTypes}
                items={properties.payment_types?.items}
              />
            </div>
          </div>
        </>
      )}
      {properties?.insurances_in_network && (
        <div className="bookings__row">
          <p className="bookings__row__label main-title less-padding">Insurance</p>
          <p className="bookings__row__label">
            {properties?.insurances_in_network?.description
              || 'Which dental insurances are in network for you?'}
          </p>
          <div className="bookings__row__input">
            <TextareaField
              count
              max={160}
              style={{ width: '100%' }}
              value={values.insurances_in_network || ''}
              onChange={getHandler('insurances_in_network')}
            />
          </div>
        </div>
      )}
      {properties?.special_offer && (
        <>
          <div className="bookings__row">
            <p className="bookings__row__label main-title no-btm-padding">Special Offers</p>
          </div>
          <div className="bookings__row">
            <div className="bookings__row__input reduce-padding">
              <SpecialOffers
                value={values.specialOffers}
                errors={filterErrors('specialOffers', errors)}
                onChange={(touched, value) => {
                  onChange('specialOffers', value, touched);
                }}
                recipients={recipients}
                items={properties?.special_offer?.items}
              />
            </div>
          </div>
        </>
      )}
      {properties?.billing_related && (
        <>
          <div className="chats__row">
            <p className="chats__row__label">
              {properties?.billing_related?.description
                || 'How would you like TrueLark to respond if a patient has a question about their bill?'}
            </p>
          </div>
          <div className="chats__row">
            <div className="chats__row__input chat-textarea">
              <TextareaField
                count
                max={160}
                label=""
                value={preferences.billing_related || ''}
                name="billing_related"
                onChange={onInputChange}
                error={errors.billing_related}
              />
            </div>
          </div>
        </>
      )}
      {properties?.new_patient_consultation_billing && (
        <>
          <div className="chats__row">
            <p className="chats__row__label">
              {properties?.new_patient_consultation_billing?.description
                || 'How would you like TrueLark to respond when asked about the cost of the initial consultation for a new patient?'}
            </p>
          </div>
          <div className="chats__row">
            <div className="chats__row__input chat-textarea">
              <TextareaField
                count
                max={160}
                label=""
                value={preferences.new_patient_consultation_billing || ''}
                name="new_patient_consultation_billing"
                onChange={onInputChange}
                error={errors.new_patient_consultation_billing}
              />
            </div>
          </div>
        </>
      )}
      {properties?.cleaning_cost && (
        <>
          <div className="chats__row">
            <p className="chats__row__label">
              {properties?.cleaning_cost?.description
                || 'How would you like TrueLark to respond when someone asks about the cost of a cleaning?'}
            </p>
          </div>
          <div className="chats__row">
            <div className="chats__row__input chat-textarea">
              <TextareaField
                count
                max={160}
                label=""
                value={preferences.cleaning_cost || ''}
                name="cleaning_cost"
                onChange={onInputChange}
                error={errors.cleaning_cost}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

ClientBilling.defaultProps = {
  onChange: () => { },
  values: {},
  errors: {},
  disabled: false,
  paymentTypes: [],
  insurances: [],
  recipients: [],
};

ClientBilling.propTypes = {
  onChange: PropTypes.func,
  values: PropTypes.shape(),
  paymentTypes: PropTypes.arrayOf(PropTypes.shape()),
  insurances: PropTypes.arrayOf(PropTypes.shape()),
  recipients: PropTypes.arrayOf(PropTypes.shape()),
  errors: PropTypes.shape(),
};
